import { getAllAppliedImprintAreaKeys, getAllSelectedImprintAreaKeys } from '../../imprintarea/selectors';

import { changeBomColor } from '../../preview/actions';
import { changeCurrentPreviewElementsAction } from '../actions';
import { changePreviewDefaultImprintColor } from '../../preview/logics';
import { getAllNextGenUIImprintAreaKeys } from '../../imprintarea/selectors';
import { getBomColorsInfo } from '../../preview/selectors';
import { getCanvasImageDataDict } from '../../canvas/selectors';
import { getCanvasTextDataDict } from '../../text/selectors';
import { getFullPreviewDict } from '../../preview/selectors';
import { getStudioItemType } from '../../main/selectors';
import { previewType } from '../../utils/constants';
import { setCurrentBomOption } from '../actions';
import { showMessageBox } from '../../main/actions';
import { studioItemType as studioItemTypeEnum } from '../../main/constants';

export const changeCurrentPreviewElementsLogic = () => (dispatch, getState) => {
  const state = getState();
  const logoList = getCanvasImageDataDict(state);
  const textList = getCanvasTextDataDict(state);
  dispatch(changeCurrentPreviewElementsAction({ image: logoList, text: textList }));
};

export const checkFullPreview = () => (dispatch, getState) => {
  const state = getState();
  const fullPreviewDict = getFullPreviewDict(state);
  const allSelectedImprintAreaKeys = getAllSelectedImprintAreaKeys(state);
  const allSelectedCustomizedImprintAreaKeys = getAllAppliedImprintAreaKeys(state);
  const studioItemType = getStudioItemType(state);
  let hasValidFullPreview = true;
  const hasPreview = allSelectedImprintAreaKeys.some(
    (selectedImprintAreaKey) =>
      fullPreviewDict[selectedImprintAreaKey] && fullPreviewDict[selectedImprintAreaKey].length > 0
  );
  if (!hasPreview) {
    dispatch(
      showMessageBox({
        show: true,
        message: 'Load preview failed.',
      })
    );
    hasValidFullPreview = false;
  } else if (studioItemType !== studioItemTypeEnum.nonDigital) {
    const hasVignettePreview = allSelectedImprintAreaKeys.some(
      (selectedImprintAreaKey) =>
        fullPreviewDict[selectedImprintAreaKey] &&
        fullPreviewDict[selectedImprintAreaKey].some((preview) => preview.type === previewType.Vignette)
    );

    if (!hasVignettePreview) {
      const hasFxgPreview = allSelectedImprintAreaKeys.some(
        (selectedImprintAreaKey) =>
          fullPreviewDict[selectedImprintAreaKey] &&
          fullPreviewDict[selectedImprintAreaKey].some((preview) => preview.type === previewType.Fxg)
      );
      if (hasFxgPreview) {
        //has customized fxg preview
        const hasCustomizedFxgPreview = allSelectedImprintAreaKeys.some((selectedImprintAreaKey) =>
          allSelectedCustomizedImprintAreaKeys.includes(selectedImprintAreaKey)
        );
        if (!hasCustomizedFxgPreview) {
          dispatch(
            showMessageBox({
              show: true,
              message: 'No preview available. Please customize the item with an imprint to continue.',
            })
          );
          hasValidFullPreview = false;
        }
      }
    }
  }
  return hasValidFullPreview;
};
